import { Box, Button, CircularProgress, Typography, withStyles } from "@material-ui/core";
import React, { useReducer, useRef, useState } from "react";
import Styles from "../commonStyles";
import AuthContainer from "../_components/AuthContainer";
import InputPaper from "../_components/InputPaper";
import config from "../_config/config";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";
import { set2FA } from "../_helpers/cookies";
import { getErrorMsg, getErrorCode } from "../_helpers/errors";
import axios from "../_helpers/interceptor";
import { goBackToReferer, goToSetPin } from "../_helpers/navHelpers";
import useEventCallback from "../_helpers/useEventCallBack";
import CommonPopup from "../_components/CommonPopup";
import ReCAPTCHA from "react-google-recaptcha";

function makeCall(data) {
  var dt = {
    payload: [data]
  };
  return axios.post(`${config.endpoint}${config.enterpin}`, dt);
}

function reducerFunction(state, action) {
  const { ERRORS: { E_PIN } } = strings;
  switch (action.type) {
    case actions.ENTER_PIN:
      state.enterpin = action.data;
      state.googleCaptchaVal = action.googleCaptchaVal;
      if (action.data && (action.data.length < 4 || action.data.length > 4)) {
        state.error = { enterpin: E_PIN };
      } else {
        state.error = {};
      }
      return { ...state };
    case actions.SUBMIT_PIN: case actions.FORGOT_PIN:
      state.submitting = true;
      state.success = false;
      state.pinSubmitted = action.data;
      action.callBack(state);
      return { ...state };
    case actions.SUBMIT_PIN_SUCCESS:
      state.submitting = false;
      state.success = true;
      state.error = {};
      return { ...state };
    case actions.SUBMIT_PIN_FAILURE:
      state.submitting = false;
      state.success = false;
      state.error = { msg: action.error };
      state.captchaFlag = action.captchaFlag === 1;
      action.errorCode === 1704 ? state.openPopUp = true : state.openPopUp = false;
      return { ...state };
  }
  return { ...state };
}

function EnterPin(props) {
  const { LABELS: { SUBMIT } } = strings;
  const { classes } = props;
  const [state, setState] = useReducer(reducerFunction, {
    onSubmit: false,
    submitting: false,
    enterpin: "",
    error: {},
    openPopUp: false,
    errorCode: {},
  });
  
  const { onSubmit, submitting, enterpin: enteredPin, error: { enterpin, msg }, captchaFlag } = state;

  const { TITLES: { ENTER_PIN }, MESSAGES: { ENTER_PIN_INFO } } = strings;
  const [num, setNum] = useState();
  const captchaRef = useRef();
  const googleCaptchaRef = useRef();

  const handleSubmitPin = e => {
    e && e.preventDefault();
    // if (captchaFlag) {
    //   const captchaValidation = captchaRef && captchaRef.current && captchaRef.current.validate();
    //   // captchaValue.current = captchaValidation;
    //   if (!captchaValidation) {
    //     return;
    //   }
    // }
    const googleCaptchaVal = captchaFlag ? googleCaptchaRef.current.getValue() : 'y';
    if (state.enterpin.length == 4 && googleCaptchaVal != '') {
      setState({ submitting: true, type: actions.SUBMIT_PIN, callBack: submitPin });
    } else {
      setState({ onSubmit: true });
    }
  };

  const handleEnterPin = e => {
    setState({
      type: actions.ENTER_PIN,
      data: e.target.value
    });
  };

  const onCaptchaChange = val => {
    setState({ type: actions.ENTER_PIN, data: enteredPin, googleCaptchaVal: val });
  };

  const handleForgotPin = (e) => {
    e.preventDefault();
    setState({ type: actions.FORGOT_PIN, callBack: forgotPin });
  };

  const forgotPin = () => {
    goToSetPin(props.history);
  }

  const submitPin = (state) => {
    makeCall({ pin: state.enterpin,
    ...(captchaFlag ? {
        captchaResponse: googleCaptchaRef.current.getValue()
      }: {}) }).then(useEventSubmitPin).catch(useEventSubmitPin);
  }
  const reponseSubmitPin = resp => {
    if (resp && resp.data && resp.data.success) {
      set2FA(resp.data.success.access_token);
      setState({
        type: actions.SUBMIT_PIN_SUCCESS,
        data: resp.data.success
      });
      goBackToReferer(window);
      // let referer = getReferer();
      // window.location.href = (referer && atob(referer)) || config.contentendpoint;
    } else {
      googleCaptchaRef.current && googleCaptchaRef.current.reset();
      setState({
        //TODO: read from 'capchaFlag'
        type: actions.SUBMIT_PIN_FAILURE,
        // error: resp && resp.data && resp.data.error && resp.data.error.errordesc ? resp.data.error.errordesc : 'Invalid Pin.'
        error: getErrorMsg(resp) || 'Invalid Pin.',
        errorCode: getErrorCode(resp),
        captchaFlag: resp.data.error.capchaFlag,
      });
    }
  };

  const handlepopup =()=>{
    window.open("/","_self")
  }

  const hanldeKeyPress=(e)=>{
    var char = e.target.value.replace(/[^0-9]/g, '');
    setNum(char)
  }

  const useEventSubmitPin = useEventCallback(reponseSubmitPin, [state, setState]);

  return (
    <AuthContainer formtype="enter pin">
      <Box className={classes.formBox}>
        <Typography gutterBottom className={classes.formtitle}>
          {ENTER_PIN}
        </Typography>

        <InputPaper
          autoFocus
          inputtype="password"
          value={num}
          name="Enter pin"
          placeholder="Enter Pin"
          handler={handleEnterPin}
          image="../images/lockicon.svg"
          alt_text="lock-icon"
          errorPos='top'
          onChange={(e)=>hanldeKeyPress(e)}
          errorMsg={!!enterpin ? enterpin : null}
          disabled={submitting}
        />

        <Typography
          className={classes.errormsg}
          variant="caption"
          display="block"
          gutterBottom
        >
          {msg}
        </Typography>

        {captchaFlag && <ReCAPTCHA
          ref={googleCaptchaRef}
          style={{ display: "inline-block", marginBottom: 10 }}
          size="normal"
          // size="invisible"
          sitekey="6LcaCSkeAAAAAHe_pYkugmdMro_bmzcoFk8HiCZj"
          onChange={onCaptchaChange}
        />}

        <Typography
          className={classes.infomsg}
          variant="caption"
          display="block"
          gutterBottom
        >
          {ENTER_PIN_INFO}
        </Typography>

        <Button
          variant="contained"
          type="submit"
          className={classes.loginbutton}
          onClick={handleSubmitPin}
          disabled={submitting}
        >
          {SUBMIT}
          {submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
        </Button>
        <CommonPopup
          openState={state.openPopUp}
          popupText={msg}
          handleClick={handlepopup}
        ></CommonPopup>
        {/* <a
          href=""
          className={classes.fgtpasswdlink}
          onClick={handleForgotPin}
        >
          Forgot PIN
              </a> */}
      </Box>
    </AuthContainer>
  );
}
export default withStyles(Styles)(EnterPin);
